import React, { useEffect, useState } from "react";
import styles from "./styles";
import { Grid } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import Axis from "../../../../images/axis.svg";
import Curves from "../../../../images/curves.svg";
import Dotted from "../../../../images/dotted.svg";
import horGreen from "../../../../images/horGreen1.svg";
import horRed from "../../../../images/horRed.svg";
import vertRed from "../../../../images/vertRed.svg";
import vertBlue from "../../../../images/vertBlue.svg";
import HorBlue from "../../../../images/horBlue1.svg";
import HorWhite from "../../../../images/horWhite1.svg";
import VertWhite from "../../../../images/vertWhite.svg";

const LineDotBothHandler = (props) => {
  const {
    classes,
    submitted,
    setAnsweredCorrectly,
    questionAnswer,
    setAnswers,
    answers,
    setAnsweredPartialy,
  } = props;

  const [onSelect, setOnSelect] = useState(-1);
  const [selected, setSelected] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState(questionAnswer.answer);

  const [horBlueLine, setHorBlueLine] = useState(false);
  const [vertBlueLine, setVertBlueLine] = useState(false);

  const [horGreenLine, setHorGreenLine] = useState(false);
  const [vertGreenLine, setVertGreenLine] = useState(false); //not in use now

  const [horRedLine, setHorRedLine] = useState(false);
  const [vertRedLine, setVertRedLine] = useState(false);

  const _onMouseMove = (e) => {
    // console.log(e.screenX - e.screenY);
    // this.setState({ x: e.screenX, y: e.screenY });
  };

  const changeBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#a3cfd9";
    }
  };

  const resetBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#fff";
    }
  };

  console.log("onSelect", onSelect);

  const markSelected = (triangle) => {
    if (!submitted) {
      setOnSelect(1);
      let temp = selected;
      if (selected.includes(triangle)) {
        const index = temp.indexOf(triangle);
        // if (index > -1) {
        temp.splice(index, 1);
        // }
        // temp.pop(triangle);
        setSelected(temp);
      } else {
        temp.push(triangle);
        setSelected(temp);
      }

      if (!submitted && selected.includes(1) && selected.includes(5)) {
        setHorBlueLine(true);
      } else {
        setHorBlueLine(false);
      }

      if (!submitted && selected.includes(3) && selected.includes(6)) {
        setVertBlueLine(true);
      } else {
        setVertBlueLine(false);
      }
      console.log("selected", triangle);
    }
  };

  useEffect(() => {
    setOnSelect(2);
  }, [onSelect]);

  useEffect(() => {
    // const answer =
    //   selected.includes(questionAnswer.answer) && selected.length === 1;
    // if (submitted) {
    //   let tempAnswer = answers;
    //   if (answer) {
    //     tempAnswer.push(true);
    //     setAnswers(tempAnswer);
    //     setHorGreenLine(true);
    //     //correct horizontal line
    //   } else {
    //     tempAnswer.push(false);
    //     setAnswers(tempAnswer);
    //     if (selected.includes(5)) {
    //       // red horizontal line
    //       setHorRedLine(true);
    //     }
    //     if (selected.includes(1)) {
    //       // red horizontal line
    //       setHorRedLine(true);
    //     }
    //     if (selected.includes(6) || selected.includes(3)) {
    //       // red horizontal line
    //       setVertRedLine(true);
    //     }
    //   }
    // }

    let is_true = true;
    questionAnswer.answer.map((ans) => {
      if (!selected.includes(ans)) {
        is_true = false;
      }
    });

    const answer = is_true && selected.length === questionAnswer.answer.length;
    if (submitted) {
      let tempAnswer = answers;
      if (answer) {
        tempAnswer.push(true);
        setAnswers(tempAnswer);
        // if (
        //   questionAnswer.answer.includes(1) ||
        //   questionAnswer.answer.includes(5)
        // ) {
        //   // setHorBlueLine(false);
        //   setHorGreenLine(true);
        // }
        // if (
        //   questionAnswer.answer.includes(4) ||
        //   questionAnswer.answer.includes(6)
        // ) {
        //   // setVertBlueLine(false);
        //   setVertGreenLine(true);
        // }
        setAnsweredCorrectly(true);
      } else {
        tempAnswer.push(false);
        setAnswers(tempAnswer);
        let is_partial = false;
        if (selected.length < questionAnswer.answer.length) {
          selected.map((ans) => {
            is_partial = true;
            if (!questionAnswer.answer.includes(ans)) {
              is_partial = false;
            }
          });
        }
        if (is_partial) {
          setAnsweredPartialy(true);
        } else {
          setAnsweredCorrectly(false);
          setAnsweredPartialy(false);
          if (selected.includes(5)) {
            // red horizontal line
            setHorRedLine(true);
          }
          if (selected.includes(1)) {
            // red horizontal line
            setHorRedLine(true);
          }
          if (selected.includes(6) || selected.includes(3)) {
            // red horizontal line
            setVertRedLine(true);
          }
        }
      }

      if (
        questionAnswer.answer.includes(1) ||
        questionAnswer.answer.includes(5)
      ) {
        // setHorBlueLine(false);
        setHorRedLine(false);
        setHorGreenLine(true);
      }
      if (
        questionAnswer.answer.includes(4) ||
        questionAnswer.answer.includes(6)
      ) {
        // setVertBlueLine(false);
        setVertGreenLine(true);
      }
    }
  }, [submitted]);

  // useEffect(() => {
  //   if (horGreenLine) {
  //     setAnsweredCorrectly(true);
  //   } else {
  //     setAnsweredCorrectly(false);
  //   }
  // }, [horGreenLine]);

  const checkSelection = (triangle) => selected.includes(triangle);

  const demandCurveResponsive = () => {
    return (
      <div className={classes.domasticContainer}>
        <div className={classes.innerContainer} onMouseMove={_onMouseMove}>
          <img src={Axis} style={{ height: "100%", zIndex: 2 }} alt="" />
          <img
            src={Curves}
            style={{ height: "100%", position: "absolute", zIndex: 2 }}
            alt=""
          />
          {/* <img src={Dotted} style={{ height: "100%", position: "absolute" }} /> */}

          <img src={HorWhite} className={classes.horWhite} alt="" />
          <img src={VertWhite} className={classes.VertWhite} alt="" />

          <img
            src={HorBlue}
            className={classes.HorBlue}
            style={{
              zIndex: horBlueLine ? 1 : -1,
            }}
            alt=""
          />
          <img
            src={vertBlue}
            className={classes.VertBlue}
            style={{
              zIndex: vertBlueLine ? 1 : -1,
            }}
            alt=""
          />

          <img
            src={horGreen}
            className={classes.HorGreen}
            style={{
              zIndex: horGreenLine ? 1 : -1,
            }}
            alt=""
          />

          <img
            src={horRed}
            className={classes.HorRed}
            style={{
              zIndex: horRedLine ? 1 : -1,
            }}
            alt=""
          />

          <img
            src={vertRed}
            className={classes.VertRed}
            style={{
              zIndex: vertRedLine ? 1 : -1,
            }}
            alt=""
          />

          {/* <img
            src={vertGreen}
            style={{
              height: "34%",
              top: 195,
              right: 98,
              position: "absolute",
              zIndex: vertGreenLine ? 1 : -1,
            }}
            alt=""
          /> */}

          <div className={classes.TopRight}>
            <div
              className={classes.Triangle1}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(1)
                    ? "green"
                    : selected.includes(1)
                    ? "red"
                    : "#fff"
                  : selected.includes(1)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(1)
                  ? console.log("1")
                  : !checkSelection(1) && resetBackground
              }
              onMouseOver={
                selected.includes(1)
                  ? console.log("1")
                  : !checkSelection(1) && changeBackground
              }
              onClick={() => markSelected(1)}
            />

            <div
              className={classes.Triangle2}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(2)
                    ? "green"
                    : selected.includes(2)
                    ? "red"
                    : "#fff"
                  : selected.includes(2)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(2)
                  ? console.log("2")
                  : !checkSelection(2) && resetBackground
              }
              onMouseOver={
                selected.includes(2)
                  ? console.log("2")
                  : !checkSelection(2) && changeBackground
              }
              onClick={() => markSelected(2)}
            />

            <div
              className={classes.Triangle3}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(3)
                    ? "green"
                    : selected.includes(3)
                    ? "red"
                    : "#fff"
                  : selected.includes(3)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(3)
                  ? console.log("3")
                  : !checkSelection(3) && resetBackground
              }
              onMouseOver={
                selected.includes(3)
                  ? console.log("3")
                  : !checkSelection(3) && changeBackground
              }
              onClick={() => markSelected(3)}
            />

            <div
              className={classes.Triangle4}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(4)
                    ? "green"
                    : selected.includes(4)
                    ? "red"
                    : "#fff"
                  : selected.includes(4)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(4)
                  ? console.log("4")
                  : !checkSelection(4) && resetBackground
              }
              onMouseOver={
                selected.includes(4)
                  ? console.log("4")
                  : !checkSelection(4) && changeBackground
              }
              onClick={() => markSelected(4)}
            />
          </div>
          <div className={classes.bottomLeft}>
            <div
              className={classes.Triangle5}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(5)
                    ? "green"
                    : selected.includes(5)
                    ? "red"
                    : "#fff"
                  : selected.includes(5)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(5)
                  ? console.log("5")
                  : !checkSelection(5) && resetBackground
              }
              onMouseOver={
                selected.includes(5)
                  ? console.log("5")
                  : !checkSelection(5) && changeBackground
              }
              onClick={() => markSelected(5)}
            ></div>
            <div
              className={classes.Triangle6}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(6)
                    ? "green"
                    : selected.includes(6)
                    ? "red"
                    : "#fff"
                  : selected.includes(6)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(6)
                  ? console.log("6")
                  : !checkSelection(6) && resetBackground
              }
              onMouseOver={
                selected.includes(6)
                  ? console.log("6")
                  : !checkSelection(6) && changeBackground
              }
              onClick={() => markSelected(6)}
            ></div>
          </div>
        </div>
      </div>
    );
  };

  return <Grid style={{ width: 420 }}>{demandCurveResponsive()}</Grid>;
};

export default withStyles(styles)(LineDotBothHandler);
